import { Project } from '../../../../../entities/projects/types/project.types'

export const createProjectInitialValues = (form: Omit<Project, 'id' | 'createdAt' | 'updatedAt'> | null) => {
  if (form) {
    return {
      name: form.name,
      organizationId: form.organizationId,
    }
  }

  return {
    name: '',
    organizationId: 0,
  }
}
